
(() => {
  const root = document.documentElement;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  root.classList.add('rr-motion-ready');
  const items = document.querySelectorAll('[data-rr-reveal]');
  if (!items.length) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('rr-is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
  items.forEach((item) => observer.observe(item));
})();

/* ROOMROOT mobile atmosphere rail reachability fix */
(() => {
  const styleId = 'rr-atmosphere-mobile-rail-fix';
  if (document.getElementById(styleId)) return;
  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    @media (max-width: 749px) {
      .rr-atmosphere__modebar {
        min-width: 0 !important;
      }
      .rr-atmosphere__modes {
        display: flex !important;
        flex-wrap: nowrap !important;
        overflow-x: scroll !important;
        overflow-y: hidden !important;
        width: calc(100% + 2rem) !important;
        max-width: none !important;
        margin-inline: -1rem !important;
        padding: .25rem max(4rem, calc(1rem + env(safe-area-inset-right))) .75rem max(1rem, env(safe-area-inset-left)) !important;
        scroll-padding-inline: max(1rem, env(safe-area-inset-left)) max(4rem, calc(1rem + env(safe-area-inset-right))) !important;
        scrollbar-width: none !important;
        -webkit-overflow-scrolling: touch !important;
        overscroll-behavior-inline: contain;
        touch-action: pan-x pan-y;
      }
      .rr-atmosphere__modes::-webkit-scrollbar {
        display: none !important;
      }
      .rr-atmosphere__modes > .rr-atmosphere__mode {
        flex: 0 0 auto !important;
      }
      .rr-atmosphere__modes::after {
        content: '';
        display: block;
        flex: 0 0 max(3.5rem, env(safe-area-inset-right));
        width: max(3.5rem, env(safe-area-inset-right));
        height: 1px;
        pointer-events: none;
      }
    }
  `;
  document.head.appendChild(style);
})();
